import { Command } from 'commander';
import chalk from 'chalk';
import { createKitListCommand } from './list.js';
import { createKitInfoCommand } from './info.js';
import { createKitCreateCommand } from './create.js';

function showKitHelp(): void {
    console.log(chalk.bold.cyan('📦 jai1 kit') + chalk.dim(' - Quản lý starter kits'));
    console.log();
    console.log(chalk.bold('Các lệnh:'));
    console.log(`  ${chalk.cyan('list')}     Liệt kê các starter kits có sẵn`);
    console.log(`  ${chalk.cyan('info')}     Xem chi tiết một starter kit`);
    console.log(`  ${chalk.cyan('create')}   Tạo project mới từ starter kit`);
    console.log();
    console.log(chalk.bold('Ví dụ:'));
    console.log(chalk.dim('  $ jai1 kit list'));
    console.log(chalk.dim('  $ jai1 kit list --category frontend'));
    console.log(chalk.dim('  $ jai1 kit info next-tw4-shadcn'));
    console.log(chalk.dim('  $ jai1 kit create next-tw4-shadcn my-project'));
    console.log();
    console.log(chalk.dim('Chạy "jai1 kit <lệnh> --help" để xem chi tiết'));
}

export function createKitCommand(): Command {
    const cmd = new Command('kit')
        .description('Manage starter kits for new projects')
        .action(() => {
            showKitHelp();
        });

    cmd.addCommand(createKitListCommand());
    cmd.addCommand(createKitInfoCommand());
    cmd.addCommand(createKitCreateCommand());

    return cmd;
}
